import { RefObject } from 'react';
import { scrollToRef } from '@/common/utils/scroll-to-ref';
import { Button } from '@/shadcn-ui/button';
import ArrowWithTailRight from '@/icons/arrow-with-tail-right';
import { colors } from '@/theme/colors';
import { AnimatePresence, motion } from 'motion/react';

// Initial offset is the distance between right edge of button to right edge of viewport plus width of button
const initialOffset = 72;

interface ScrollToTopButtonProps {
  show: boolean;
  refToScrollTo: RefObject<HTMLElement | null>;
}

export default function ScrollToTopButton({
  show,
  refToScrollTo,
}: ScrollToTopButtonProps) {
  const onClick = () => {
    scrollToRef(refToScrollTo, 'top');
  };

  return (
    <>
      <AnimatePresence>
        {show ? (
          <motion.div
            className="fixed bottom-[84px] right-[10px] z-1"
            initial={{
              opacity: 0,
              x: initialOffset,
              scale: 0.98,
            }}
            animate={{
              opacity: 1,
              x: 0,
              scale: 1,
            }}
            exit={{
              opacity: 0,
              x: initialOffset,
              scale: 0.98,
            }}
            transition={{
              duration: 0.5,
              ease: 'easeInOut',
            }}
          >
            <Button
              variant="clear"
              className="h-fit w-fit -rotate-90 rounded-full bg-flexcar-neutral100/90 p-[12px] shadow-shadow25 backdrop-blur-[20px]"
              onClick={onClick}
            >
              <ArrowWithTailRight
                fillPrimary={colors.neutral1}
                hoverFillPrimary="group-hover:fill-flexcar-blue40"
                className="h-[24px] w-[24px]"
              />
            </Button>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </>
  );
}
